import { NgClass } from '@angular/common'
import { Component, input } from '@angular/core'

interface Question {
  question?: string
  answer?: string
  isOpen: boolean
}

@Component({
  selector: 'dhp-questions-section',
  templateUrl: './questions-section.component.html',
  styleUrls: ['./questions-section.component.scss'],
  imports: [NgClass],
})
export class QuestionsSectionComponent {
  readonly sectionName = input<string>('')
  readonly questions = input<Question[]>([])

  toggleQuestion(index: number): void {
    this.questions()[index].isOpen = !this.questions()[index].isOpen
  }
}
